(() => {
  if (customElements.get('wsc-card-hover')) return;

  class WscCardHover extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video[data-src]');
      this.card = this.closest('.card-wrapper');
      if (!this.video || !this.card || this.cleanup) return;
      this.attempt = (this.attempt || 0) + 1;
      this.requested = false;
      this.failed = false;
      this.visible = false;
      this.hovered = this.card.matches(':hover');
      this.allowed = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      const enter = () => { this.hovered = true; this.update(); };
      const leave = () => { this.hovered = false; this.stop(); };
      const update = () => this.update();
      const error = () => { this.failed = true; this.stop(); };
      this.card.addEventListener('pointerenter', enter);
      this.card.addEventListener('pointerleave', leave);
      this.allowed.addEventListener('change', update);
      document.addEventListener('visibilitychange', update);
      this.video.addEventListener('error', error);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.update();
      });
      this.observer.observe(this.card);
      this.cleanup = () => {
        this.card.removeEventListener('pointerenter', enter);
        this.card.removeEventListener('pointerleave', leave);
        this.allowed.removeEventListener('change', update);
        document.removeEventListener('visibilitychange', update);
        this.video.removeEventListener('error', error);
        this.observer.disconnect();
      };
    }

    eligible() {
      return this.isConnected && this.hovered && this.visible && this.allowed.matches && !document.hidden && !this.failed;
    }

    stop() {
      this.attempt = (this.attempt || 0) + 1;
      this.requested = false;
      this.video?.pause();
      this.video?.classList.remove('is-playing');
    }

    update() {
      if (!this.eligible()) { this.stop(); return; }
      if (this.requested || !this.video.dataset.src) return;
      this.requested = true;
      const attempt = ++this.attempt;
      const video = this.video;
      if (!video.hasAttribute('src')) video.src = video.dataset.src;
      video.muted = true;
      try {
        Promise.resolve(video.play()).then(() => {
          if (attempt !== this.attempt || !this.eligible()) {
            if (!this.eligible() || !this.requested) video.pause();
            return;
          }
          video.classList.add('is-playing');
        }).catch(() => {
          if (attempt === this.attempt) this.stop();
        });
      } catch {
        if (attempt === this.attempt) this.stop();
      }
    }

    disconnectedCallback() {
      this.stop();
      this.cleanup?.();
      this.cleanup = null;
    }
  }

  customElements.define('wsc-card-hover', WscCardHover);
})();
